import { PreferencesBridge, PreferencesProvider } from '@frontends/util-preferences';
import { type FC, type ReactNode } from 'react';
import { useEntityConfig } from '../hooks/useEntityConfig';

export const PreferencesGateway: FC<{ children: ReactNode }> = ({ children }) => {
  const config = useEntityConfig();

  return (
    <PreferencesProvider persist={false} embeddedFrom={config.VITE_URL_ID_FRONTEND}>
      <PreferencesBridge offeredLanguages={config.VITE_CLIENT_PORTAL_SUPPORTED_LOCALES}>{children}</PreferencesBridge>
    </PreferencesProvider>
  );
};
